import { isMobile, isNative, HORIZON_SCALE, HORIZON } from './constants';
import { getStylePropertyValue } from './utils';

export let baseRem = 0;

export let realBaseRem = 0;

export const needAdapt = (rem: number) => {
  const wrapper = document.createElement('div');
  wrapper.style.cssText = `${wrapper.style.cssText}-webkit-text-size-adjust: 100% !important; text-size-adjust: 100% !important;`;
  wrapper.style.fontSize = `${rem}px`;
  const child = document.createElement('div');
  child.style.width = '1em';
  wrapper.appendChild(child);
  document.body.appendChild(wrapper);
  const realWidth = parseInt(getStylePropertyValue(child, 'width'));
  document.body.removeChild(wrapper);
  return realWidth !== rem;
};

export const getBaseRem = (viewport: boolean = true) => {
  if (!isMobile) return 100;
  const orientation = Number(window.captchaOptions.orientation);
  let width = 0;
  if (isNative) {
    const screen = window.screen;
    width = screen.width < screen.height ? screen.width : screen.height; // 弹窗形式下，使用网页视口clientWidth计算有问题，需要使用屏幕的视口来计算
  } else {
    width = document.documentElement.clientWidth;
  }

  if (viewport !== false) {
    if (width < 320) {
      width = 320;
    }

    if (width > 540) {
      width = 540;
    }
  }

  if (isNative && orientation === HORIZON) {
    width = width * HORIZON_SCALE;
  }

  return Math.floor((width / 375) * 100);
};

export const setBaseFontSize = (
  ele: HTMLElement,
  viewport: boolean = true,
  baseREM?: number
) => {
  ele.style.cssText = `${ele.style.cssText}-webkit-text-size-adjust: 100% !important; text-size-adjust: 100% !important;`;
  const resize = () => {
    if (baseREM) {
      baseRem = baseREM;
      ele.style.fontSize = `${baseREM}px`;
    } else {
      const rem = getBaseRem(viewport);

      baseRem = rem;

      ele.style.fontSize = `${rem}px`;

      if (needAdapt(rem)) {
        const realfs = parseInt(getStylePropertyValue(ele, 'font-size'));

        if (realfs !== rem) {
          ele.style.fontSize = `${rem * (rem / realfs)}px`;
          realBaseRem = rem * (rem / realfs);
        }
      }
    }
  };

  resize();

  if (isMobile && !isNative) {
    window.removeEventListener('resize', resize);
    window.addEventListener('resize', resize);
  }

  return resize;
};
